import React from 'react';

import { __ } from '@wordpress/i18n'; 
const getImageUrl = () => {
    if (typeof window.thhaAdminSettings !== 'undefined' && window.thhaAdminSettings.assets_url) {
        return window.thhaAdminSettings.assets_url + 'img/unlock-pro-img.jpg';
    }
    return 'none'; 
};


const UnlockProBanner = () => {
    
    return (
        <div className='welcome-widget-container' >
            <div className='welcome-widget-content'>
                <div className="subheading"><span className="thha-icon thha-icon-unlock-pro " ></span> Unlock Pro Features</div>
                <h1 className='welcome-widget-title' >{__('Awesome Design With Huge Addons Pro! ', 'huge-addons-for-elementor')}</h1>
                <p className='welcome-widget-description'>
                    {__('We designed huge addons to be intuitive but we do recommend learning how it works by checking our Widget', 'huge-addons-for-elementor')}
                </p>
                <div className="features-list">
                    <ul>
                        <li><span className="thha-icon thha-icon-check"></span>{__('Marketing Widget ', 'huge-addons-for-elementor')}</li>
                        <li><span className="thha-icon thha-icon-check"></span>{__('Marketing Widget ', 'huge-addons-for-elementor')}</li>
                        <li><span className="thha-icon thha-icon-check"></span>{__('Woo Commerce', 'huge-addons-for-elementor')}</li>
                        <li><span className="thha-icon thha-icon-check"></span>{__('Woo Commerce', 'huge-addons-for-elementor')}</li>
                        <li><span className="thha-icon thha-icon-check"></span>{__('Header Footer Builder', 'huge-addons-for-elementor')}</li>
                        <li><span className="thha-icon thha-icon-check"></span>{__('Header Footer Builder', 'huge-addons-for-elementor')}</li>
                    </ul>
                </div>
                <div className="button-container style-2" >
                    <a href="#" className="upgrade-now" >{__('Upgrade Now', 'huge-addons-for-elementor')}
                    </a>
                    <a href="admin.php?page=thha-addons-manager&tab=free-vs-pro" className="guide-link" >
                        {__('Free Vs Pro', 'huge-addons-for-elementor')}
                    </a>
                </div>
            </div>
            
            <div className="image-placeholder"  style={{backgroundImage: `url(${getImageUrl()})`, width: '372px', height:'313px'}} aria-label="Product demonstration graphic">
            </div>
        </div>
    );
};

export default UnlockProBanner;